import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddCateringType = ({ show, onClose, onCreated }) => {
    const [cateringType, setCateringType] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const handleDescriptionChange = (e) => {
        const value = e.target.value;
        const capitalized = value.charAt(0).toUpperCase() + value.slice(1);
        setDescription(capitalized);
    };

    const handleSubmit = async () => {
        const newErrors = {};

        if (!cateringType.trim()) {
            newErrors.catering_type = ['Catering Type is required.'];
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setIsSubmitting(true);
        setErrors({});

        try {
            const response = await axios.post(`${baseURL}/cateringtype/add_catering`, {
                catering_type: cateringType,
                description: description,
                created_by: parseInt(localStorage.getItem("user_id")) || null
            });

            toast.success('Catering Type created successfully!');
            setCateringType('');
            setDescription('');
            onClose();
            if (onCreated) onCreated();
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Something went wrong while creating Catering Type.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <Modal show={show} size="md" onHide={onClose}>
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                        <h3 className="modal-title text-white">Create Catering Type</h3>
                        <Button
                            variant=""
                            type="button"
                            className="close px-6 py-2"
                            onClick={onClose}
                        >
                            <span className="text-white">×</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">
                                    Catering Type<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.catering_type ? 'is-invalid' : ''}`}
                                    placeholder="Enter Catering Type"
                                    value={cateringType}
                                    onChange={(e) => setCateringType(e.target.value)}
                                />
                                {errors.catering_type && (
                                    <small className="text-danger">{errors.catering_type[0]}</small>
                                )}
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea
                                    rows={8}
                                    className="form-control"
                                    placeholder="Description"
                                    value={description}
                                    onChange={handleDescriptionChange}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={handleSubmit}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Creating...' : 'Create Catering Type'}
                                <i className="fas fa-angle-double-right ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AddCateringType;
